"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemDescription = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../constants");
var _context = require("../context");
var _Description = require("./Description");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  ownerState: {
    isSmall
  },
  theme
}) => ({
  gridArea: 'product',
  alignSelf: 'start',
  boxSizing: 'border-box',
  overflow: 'hidden',
  display: 'grid',
  gridTemplateColumns: 'auto',
  gridTemplateRows: 'auto auto auto',
  width: '100%',
  alignItems: 'start',
  gap: theme.spacing(1),
  ...(!isSmall && {
    [theme.breakpoints.up('sm')]: {
      maxWidth: `${theme.breakpoints.values.md - 1 - _constants.SM_IMAGE_SIZE + _constants.SM_COLUMN_GAP + 2 * _constants.SM_OUTER_PADDING}px`
    },
    [theme.breakpoints.up('md')]: {
      width: 'auto'
    }
  })
}));
const Name = (0, _mui.styled)('div')(({
  ownerState: {
    isSmall
  },
  theme
}) => ({
  fontSize: theme.typography.body1.fontSize,
  width: '100%',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
  textWrap: 'balance',
  ...(!isSmall && {
    [theme.breakpoints.up('md')]: {
      display: 'block',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  })
}));
const BrandName = (0, _mui.styled)('span')(({
  theme
}) => ({
  fontSize: theme.typography.overline.fontSize,
  letterSpacing: 2,
  textTransform: 'uppercase',
  color: theme.palette.text.secondary
}));
const BrandLink = (0, _mui.styled)('a')(({
  theme
}) => ({
  fontSize: theme.typography.overline.fontSize,
  letterSpacing: 2,
  textTransform: 'uppercase',
  color: theme.palette.text.secondary
}));
const NameInner = (0, _mui.styled)('span')(({
  theme
}) => ({
  fontSize: theme.typography.body1.fontSize,
  display: 'inline'
}));
const NameLink = (0, _mui.styled)('a')(({
  theme
}) => ({
  fontSize: theme.typography.body1.fontSize,
  display: 'inline'
}));
const InfoSection = (0, _mui.styled)('div')({
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  justifyContent: 'start',
  alignContent: 'center',
  justifyItems: 'start',
  alignItems: 'center'
});
const ItemDescription = () => {
  const {
    brand,
    code,
    flags,
    infoAddon,
    itemTestId,
    name,
    shade,
    url,
    isSmall
  } = (0, _context.useItemContext)();
  const theme = (0, _mui.useTheme)();
  // at the moment we use only the first flag
  const flag = flags && flags.length > 0 ? flags[0] : undefined;
  const showInfo = typeof infoAddon === 'string' && infoAddon.length > 0;
  const showShade = Boolean(shade && !showInfo);
  const isBrandLink = Boolean(brand && url);
  const isBrandName = Boolean(brand && !url);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    ownerState: {
      isSmall: isSmall ?? false
    },
    children: [flag ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Description.ItemLabel, {
        testId: `${itemTestId}-flags`,
        ...flag
      })
    }) : null, isBrandLink ? /*#__PURE__*/(0, _jsxRuntime.jsx)(BrandLink, {
      href: url,
      "data-testid": `${itemTestId}-brand`,
      children: brand
    }) : isBrandName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(BrandName, {
      "data-testid": `${itemTestId}-brand`,
      children: brand
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(Name, {
      "data-testid": `${itemTestId}-description`,
      ownerState: {
        isSmall: isSmall ?? false
      },
      children: url === undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)(NameInner, {
        children: name
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(NameLink, {
        href: url,
        children: name
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(InfoSection, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "caption",
        color: theme.palette.text.secondary,
        "data-testid": `${itemTestId}-code`,
        children: code
      }), showInfo ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Description.ItemAdditionalInfo, {
        infoText: infoAddon,
        itemTestId: itemTestId
      }) : null, showShade ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Description.ItemShade, {
        code: code,
        itemTestId: itemTestId,
        shade: shade
      }) : null]
    })]
  });
};
exports.ItemDescription = ItemDescription;